import React, { Component } from 'react';
import { connect } from 'react-redux';
import Paper from 'material-ui/Paper';
import Typography from 'material-ui/Typography';
import moment from 'moment';
import Button from 'material-ui/Button';
import { withStyles } from 'material-ui/styles';
import { getCurrentUser, getCurrentUserRole } from '../user.selectors';
import ChangePasswordDialog from './ChangePasswordDialog';
import * as UserActions from '../user.actions';
import { PageAppBar } from '../../core/components/';
import { roleToString } from '../../../utils/user-utils';
import { UserRoles } from '../user.constants';
import ReportSubscriptions from './ReportSubscriptions';
import clone from 'lodash/clone';

const styles = theme => ({
  root: {
    backgroundColor: theme.palette.background.default,
  },
  paper: {
    // padding: theme.spacing.unit * 2,
    maxWidth: 1040,
    margin: '0 auto',
  },
  value: {
    fontSize: '16px',
    lineHeight: '24px',
    color: 'rgba(0, 0, 0, 0.83)',
    marginBottom: '1.5rem',
  },
  valueLast: {
    fontSize: '16px',
    lineHeight: '24px',
    color: 'rgba(0, 0, 0, 0.83)',
    marginBottom: 0,
  },
  h1: {
    paddingTop: '0px',
  },
  wrapper: {
    padding: theme.spacing.unit * 2,
  },
});

class Profile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
    };
  }

  handleClickOpen = () => {
    this.setState({
      open: true,
    });
  };

  handleRequestClose = () => {
    this.setState({ open: false });
  };

  handleRequestChange = value => {
    const { changePassword } = this.props;
    this.setState({ open: false });
    if (value) changePassword(value);
  };

  onItemSelect = (brandId, typeId) => {
    const { history } = this.props;
    history.push(`/inspection/new/${brandId}/${typeId}`);
  };

  renderItem = (item, index) => {
    return (
      <Button button key={`item-${index}`} onClick={(this.onItemSelect, item.brandId, item.typeId)}>
        <Typography>{item.label}</Typography>
      </Button>
    );
  };

  onSubscriptionChange = subscribedReports => {
    let { updateUser, currentUser } = this.props;
    let user = clone(currentUser, true);
    user.subscribedReports = subscribedReports;
    updateUser(user);
  };

  render() {
    const { currentUser, role, backPath, classes, online } = this.props;
    const hasReportSubscriptions = role === UserRoles.DEPARTMENT || role === UserRoles.SUPERUSER;
    const subscribedReports = currentUser ? currentUser.subscribedReports : [];

    if (currentUser == null) return null;
    return (
      <div className={classes.root}>
        <PageAppBar title={'Omat tietoni'} backPath={backPath} />
        <Paper className={classes.paper}>
          <div className={classes.wrapper}>
            <Typography type="headline" gutterBottom className={classes.h1}>
              {currentUser.firstName + ' ' + currentUser.lastName}
            </Typography>
            <Typography type="caption" gutterBottom>
              Liittynyt
            </Typography>
            <Typography className={classes.value} gutterBottom>
              {moment(currentUser.createdAt).format('D.M.YYYY')}
            </Typography>
            <Typography type="caption" gutterBottom>
              Käyttöoikeudet
            </Typography>
            <Typography className={classes.value} gutterBottom>
              {roleToString(role)}
            </Typography>
            <Typography type="caption" gutterBottom>
              Sähköpostiosoite
            </Typography>
            <Typography className={classes.value} gutterBottom>
              {currentUser.email}
            </Typography>
            <Typography type="caption" gutterBottom>
              Salasana
            </Typography>
            <Typography className={classes.valueLast}>••••••••</Typography>
            <Button onClick={this.handleClickOpen} color="primary" disabled={!online}>
              Vaihda salasana
            </Button>
            {hasReportSubscriptions && (
              <ReportSubscriptions subscribedReports={subscribedReports} onChange={this.onSubscriptionChange} />
            )}
            <ChangePasswordDialog
              open={this.state.open}
              onRequestClose={this.handleRequestClose}
              onRequestChange={this.handleRequestChange}
            />
          </div>
        </Paper>
      </div>
    );
  }
}

const mapStateToProps = state => {
  const currentUser = getCurrentUser(state);
  const role = getCurrentUserRole(state);
  const online = state.offline.online;
  return {
    currentUser,
    role,
    online,
  };
};

const ConnectedProfile = connect(mapStateToProps, Object.assign({}, UserActions))(Profile);

export default withStyles(styles)(ConnectedProfile);



// WEBPACK FOOTER //
// ./src/modules/user/components/Profile.js